import * as React from "react";
import "./formatting-modal.scss";

import {cs}                      from "@Common/react/chain-services";
import {ModalService3}           from "@Common/ui-components/modal-service-3/modal-service-3";

export const FormattingModal = ({next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        next: ({close}) => next({close}),
        rootNext,
        xdQaName: "Formatting Help & Special Characters"
    })],

    () => (
        <div className="formatting-modal-1wi">
            <div className="header">
                Formatting Help & Special Characters
            </div>

            <div id="text-formatting-block" className="show-text-format">
                <div className="table-view-body-container">
                    <p>Format your text and insert special characters using these simple commands:</p>
                    <div className="command-row">
                        <div className="col-md-6">
                            <p><b className="xd-help-topic">Bold:</b> Type <b className="xd-help-topic">\b</b> </p>
                            <p><b>\b</b>Xpressdocs<b>\b</b> = <b>Xpressdocs</b></p>
                            <br/>
                            <p><b className="xd-help-topic">Underline:</b> Type <b className="xd-help-topic">\u</b> </p>
                            <p><b>\u</b>Xpressdocs<b>\u</b> = <u>Xpressdocs</u> </p>
                            <br/>
                            <p><b className="xd-help-topic">Trademark &trade;:</b> Type <b className="xd-help-topic">*tm</b></p>
                            <p>Xpressdocs<b>*tm</b> = Xpressdocs&trade;</p>
                            <br/>
                            <p><b className="xd-help-topic">Bullets:</b> Type <b className="xd-help-topic">\*</b></p>
                            <p>\* Call to action <b></b> = &bull; Call to action</p>
                            <br/>
                            <br/>
                        </div>
                        <div className="col-md-6">
                            <p><b className="xd-help-topic">Italics:</b> Type <b className="xd-help-topic">\i</b> </p>
                            <p><b>\i</b>Xpressdocs<b>\i</b> = <i>Xpressdocs</i></p>
                            <br/>
                            <p><b className="xd-help-topic">Registration &reg;:</b> Type <b className="xd-help-topic">*reg</b></p>
                            <p>Xpressdocs<b>*reg</b> = Xpressdocs&reg;</p>
                            <br/>
                            <p><b className="xd-help-topic">Copyright &copy;:</b> Type <b className="xd-help-topic">*copy</b></p>
                            <p>Xpressdocs<b>*copy</b> = Xpressdocs&copy;</p>
                            <br/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 text-center bg-special">
                            <h5><strong> Special Characters </strong></h5>
                        </div>
                        <div className="col-md-12">
                            <div className="special-box">
                                <div>™    §   ©   ®   –   —   ·   ´   ß</div>
                                <br/>
                                <div>Ä	Ã	Á	À	Â	Å	Ç	É	È	Ê	Í	Ï	Î	Ñ	Ó	Õ	Ô	Ö	Ü	Ú	Ù	Û	Ø</div>
                                <br/>
                                <div>ä	ã	á	à	â	å	ç	é	è	ê	í	ï	î	ñ	ó	õ	ô	ö	ü	ú	ù	û	ø</div>
                                <br/>
                            </div>
                            <p><strong>To insert special characters:</strong></p>
                            <div className="instructions">
                                <div>1.Highlight the character you want to use, then copy it to the clipboard using the menu function 'Edit/Copy', or CTRL+C.</div>
                                <div>2.Place the cursor at the point in the line in the order form where you want the special character to appear.</div>
                                <div>3.Use the menu command 'Edit/Paste' or CTRL+V to place the special character in the line of text.</div>
                            </div>
                            <br/>
                            <br/>
                            <strong>DISCLAIMER:</strong>
                            These are the only special characters that are allowed on this site. Using methods or characters other than these for entering special characters may result in errors.
                            Some fonts may not support field text formatting. Please check your text format changes on your proof carefully.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
);
